export interface BaseSwiperImages {
  id: number;
  img: string;
  url_key: string;
}
export interface SwiperImages extends BaseSwiperImages {
  title: string;
  alt: string;
}

export const sleepWellImages: BaseSwiperImages[] = [
  {
    id: 1,
    img: '/images/homePage/swiper/westin-sleep-well-soft-hotel-pillow.webp',
    url_key: 'bedding',
  },
  {
    id: 2,
    img: '/images/homePage/swiper/westin-sleep-well-linen-set.webp',
    url_key: 'linenSet',
  },
  {
    id: 3,
    img: '/images/homePage/swiper/westin-sleep-well-pillows.webp',
    url_key: 'pillows',
  },
  {
    id: 4,
    img: '/images/homePage/swiper/westin-sleep-well-duvet.webp',
    url_key: 'duvet',
  },
  {
    id: 5,
    img: '/images/homePage/swiper/westin-sleep-well-bedding-set.webp',
    url_key: 'beddingSet',
  },
];

export const feelWellImages: BaseSwiperImages[] = [
  {
    id: 1,
    img: '/images/homePage/swiper/westin-white-tea-amenities-bath-and-body-set.webp',
    url_key: 'bathAndBodySet',
  },
  {
    id: 2,
    img: '/images/homePage/swiper/westin-white-tea-amenities-shampoo-conditioner-set.webp',
    url_key: 'shampooAndConditionerSet',
  },
  {
    id: 3,
    img: '/images/homePage/swiper/westin-white-tea-amenities-body-care-set.webp',
    url_key: 'bodyCareSet',
  },
  {
    id: 4,
    img: '/images/homePage/swiper/westin-white-tea-amenities-bath-and-body-oil.webp',
    url_key: 'bathAndBodyOil',
  },
  {
    id: 5,
    img: '/images/homePage/swiper/westin-white-tea-amenities-bar-soap.webp',
    url_key: 'soap',
  },
];

export const fragranceImages: BaseSwiperImages[] = [
  {
    id: 1,
    img: '/images/homePage/swiper/westin-white-tea-fragrance-reed-diffuser.webp',
    url_key: 'reedDiffusers',
  },
  {
    id: 2,
    img: '/images/homePage/swiper/westin-white-tea-fragrance-home-diffuser-set.webp',
    url_key: 'homeDiffuserSet',
  },
  {
    id: 3,
    img: '/images/homePage/swiper/westin-white-tea-fragrance-candle.webp',
    url_key: 'candle',
  },
  {
    id: 4,
    img: '/images/homePage/swiper/westin-white-tea-fragrance-room-spray.webp',
    url_key: 'roomSpray',
  },
  {
    id: 5,
    img: '/images/homePage/swiper/westin-white-tea-fragrance-scent-sticks.webp',
    url_key: 'scentSticks',
  },
];

export const bathImages: BaseSwiperImages[] = [
  {
    id: 1,
    img: '/images/homePage/the-westin-heavenly-towel-collection.webp',
    url_key: 'towels',
  },
  {
    id: 2,
    img: '/images/homePage/the-westin-pool-towel-collection-mob.webp',
    url_key: 'poolTowels',
  },
  {
    id: 3,
    img: '/images/homePage/the-westin-heavenly-robe-collection.webp',
    url_key: 'robes',
  },
  {
    id: 4,
    img: '/images/homePage/the-westin-bath-rug-collection-mob.webp',
    url_key: 'bathRug',
  },
  {
    id: 5,
    img: '/images/homePage/the-westin-heavenly-towel-collection.webp',
    url_key: 'towels',
  },
  {
    id: 6,
    img: '/images/homePage/the-westin-pool-towel-collection-mob.webp',
    url_key: 'poolTowels',
  },
  {
    id: 7,
    img: '/images/homePage/the-westin-heavenly-robe-collection.webp',
    url_key: 'robes',
  },
  {
    id: 8,
    img: '/images/homePage/the-westin-bath-rug-collection-mob.webp',
    url_key: 'bathRug',
  },
];
